export const capitalize = (str) => (str ? `${str[0].toLocaleUpperCase()}${str.slice(1)}` : '');

export const sentenceCase = (str) =>
  str ? `${str[0].toLocaleUpperCase()}${str.slice(1).toLocaleLowerCase()}` : '';

export const nullerize = (str) => (str && str !== 'null' ? str : null);

/* eslint-disable no-param-reassign */
export function camelize(entity, property, deleteOld = true, conversion = (v) => v) {
  if (property in entity) {
    const newProperty = property.replace(/_\w/g, (match) => match[1].toUpperCase());
    entity[newProperty] = conversion(entity[property]);
    if (deleteOld) {
      delete entity[property];
    }
  }
}
/* eslint-enable no-param-reassign */
